import { CascaderPanel } from 'element-ui'

const YCascaderPanel = CascaderPanel
YCascaderPanel.$depends = [CascaderPanel]
YCascaderPanel.$name = 'y-cascader-panel'
YCascaderPanel._name = 'cascader-panel 级联选择器面板'

export default YCascaderPanel
